import { DiagnosticRange } from "@/constants/enums/DiagnosticRange";
import {
	GET_GEN_SHAFT_UNBALANCE_RESULT,
	GET_GEN_SHAFT_UNBALANCE_CHART,
	RESET_GEN_SHAFT_UNBALANCE_RESULT,
} from "./GeneratorShaftUnbalanceActionTypes.js";

import FetchStatus from "@/constants/fetch-status/FetchStatus";

const mutations = {
	[GET_GEN_SHAFT_UNBALANCE_RESULT]: (state, resp) =>
	{
		state.status = resp.status;
		state.signalSettingIds = resp.signalSettingIds;
		state.operatingRange = resp.operatingRange;
		state.errorMessage = resp.errorMessage;
	},
	[GET_GEN_SHAFT_UNBALANCE_CHART]: (state, resp) =>
	{
		state.status = resp.status;
		state.errorMessage = resp.errorMessage;
		state.orderChartData = resp.orderChartData;
		state.orderLayout = resp.orderLayout;
		state.frequencyChartData = resp.frequencyChartData;
		state.frequencyLayout = resp.frequencyLayout;
	},
	[RESET_GEN_SHAFT_UNBALANCE_RESULT]: (state) =>
	{
		state.status = FetchStatus.Init;
		state.operatingRange = DiagnosticRange.undefined;
	},
};

export default { mutations };
